<template>
  <el-aside class="sidebar" width="200px">
    <div class="sidebar-header">
      <span class="sidebar-title">功能导航</span>
    </div>
    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      background-color="#ffffff"
      text-color="#333333"
      active-text-color="#ffffff"
      :router="true"
    >
      <el-menu-item 
        v-for="item in menuList" 
        :key="item.path" 
        :index="item.path"
      >
        <i :class="item.icon"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: 'SideBar',
  data() {
    return {
      curWebsite: this.$api.getWebsiteType(),
      menuList: [
        { path: '/dashboard', title: '项目检索', icon: 'el-icon-search' ,pathD:['/dashboard']},
        { path: '/contact', title: '联系人', icon: 'el-icon-user' ,pathD:['/contact']},
        { path: '/constructionProject', title: '建设行业库', icon: 'el-icon-coin' ,pathD:['/constructionProject']},
        { path: '/constructionIndustry', title: '建筑业数据', icon: 'el-icon-school' ,pathD:['/constructionIndustry']},
        
        // { path: '/monitoring', title: '建筑业数据', icon: 'el-icon-location' },
        // { path: '/statistics', title: '统计分析', icon: 'el-icon-data-analysis' },
        { path: '/totalEnterprises', title: '企业数据库', icon: 'el-icon-office-building' ,pathD:['/totalEnterprises','/enterpriseList']},
        { path: '/chain', title: '产业图谱库', icon: 'el-icon-paperclip' ,pathD:['/chain']},
        { path: '/report', title: '研究报告库', icon: 'el-icon-document' ,pathD:['/report']},
        // { path: '/calculator', title: '关系计算器', icon: 'el-icon-s-grid',pathD:['/calculator' ]}
      ]
    }
  },
  computed: {
    activeMenu() {
      console.log('this.$route.path:', this.$route.path);
      //对比路由和pathD对比,如果路由包含pathD中的路径，default-active就是当前路由的path
      const menuItem = this.menuList.find(item => item.pathD && item.pathD.includes(this.$route.path));
      const result = menuItem ? menuItem.path : undefined;
      return result;
      // return this.$route.path
    },
  },
  mounted() {
    if(this.curWebsite.type == 2) {
      this.menuList = this.menuList.filter(item => item.path !== '/contact' && item.path !== '/constructionProject' );
    }
    if(this.curWebsite.type == 1) {
      this.menuList = this.menuList.filter( item => item.path !== '/constructionProject' && item.path !== '/constructionIndustry');
    }
    if(this.curWebsite.type == 4) {
      this.menuList = this.menuList.filter( item => item.path !== '/contact');
    }
  }
}
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  background-color: #fff;
  border-right: 1px solid #e6e6e6;
  overflow-y: auto;
  z-index: 999;
}

.sidebar-header {
  padding: 20px 16px 10px;
  border-bottom: 1px solid #f0f0f0;
}

.sidebar-title {
  font-size: 14px;
  color: #1e3a5f;
  font-weight: 500;
  position: relative;
  padding-left: 10px;
}

.sidebar-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background-color: #1e3a5f;
  border-radius: 2px;
}

.sidebar-menu {
  border-right: none;
}

.sidebar-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 4px 8px;
  border-radius: 8px;
}

.sidebar-menu .el-menu-item.is-active {
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%) !important;
  color: #fff !important;
}

.sidebar-menu .el-menu-item:hover:not(.is-active) {
  background-color: #f5f7fa;
}

.sidebar-menu .el-menu-item i {
  margin-right: 8px;
  font-size: 18px;
}
</style>
